import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"

// Profile changes, password, MFA and devices belong to the personal /account pages.
export const getTabs = (): PageTabWithId[] => [
  { id: "profile", title: "Profil", widthType: "small" },
]
